import { useEffect, useRef } from "react";

export default function DevToolsShield() {
  const trapActive = useRef(false);
  const devToolsOpenedBefore = useRef(false);

  useEffect(() => {
    // Active in production builds only; disabled during development
    if (process.env.NODE_ENV !== "production") return;

    const REDIRECT_URL = "https://google.com";
    trapActive.current = true;
    devToolsOpenedBefore.current = false;

    const nuke = (reason) => {
      if (!trapActive.current) return;
      console.log("DevTools Shield active: " + reason);
      trapActive.current = false;
      document.body.innerHTML =
        '<h1 style="color:red; text-align:center; margin-top: 20vh; font-family: sans-serif;">Developer Mode Detected.<br/>Access Denied.</h1>';
      window.location.replace(REDIRECT_URL);
    };

    // 1. Keyboard & Context Menu
    const handleKeydown = (e) => {
      const key = e.key.toUpperCase();
      if (
        key === "F12" ||
        (e.ctrlKey && e.shiftKey && "ICJ".includes(key)) ||
        (e.ctrlKey && key === "U")
      ) {
        e.preventDefault();
      }
    };
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("keydown", handleKeydown, { capture: true });
    document.addEventListener("contextmenu", handleContextMenu, { capture: true });

    // 2. High-security Debugger Trap + Deactivation detection
    let detectionCount = 0;
    let trapTimeout;
    const triggerTrap = () => {
      if (!trapActive.current) return;

      const start = Date.now();
      try {
        // eslint-disable-next-line no-debugger
        debugger;
      } catch (e) {}
      const elapsed = Date.now() - start;

      if (elapsed > 100) {
        // We caught a real pause
        devToolsOpenedBefore.current = true;
        detectionCount++;
        if (detectionCount >= 2) nuke("Debugger Pause");
      } else {
        // A pause was detected before but now it's 0ms:
        // they must have clicked "Deactivate Breakpoints"
        if (devToolsOpenedBefore.current) {
          nuke("Breakpoints Deactivated");
          return;
        }
        detectionCount = 0;
      }
      trapTimeout = setTimeout(triggerTrap, 500);
    };
    triggerTrap();

    // 3. Console Trap
    // Simple getters are safer than toString() to avoid background false-positives.
    const consoleInterval = setInterval(() => {
      if (!trapActive.current) return;

      const trapObj = new Image();
      Object.defineProperty(trapObj, "id", {
        get: function () {
          // Only fires if the console is actually formatting/viewing this object
          nuke("Console Inspector");
          return "trap";
        },
      });

      console.log("%c", trapObj);
      if (console.clear) console.clear();
    }, 1000);

    // 4. Size Heuristic
    const checkSize = () => {
      // Skip check on mobile
      const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi/i.test(navigator.userAgent) ||
        window.innerWidth <= 800;
      if (!trapActive.current || isMobile) return;

      // Higher threshold (180px) to ignore browser sidebars and scrollbars
      const threshold = 180;
      const widthDiff = window.outerWidth - window.innerWidth;
      const heightDiff = window.outerHeight - window.innerHeight;

      if (widthDiff > threshold || heightDiff > threshold) {
        nuke("Window Dimensions");
      }
    };

    window.addEventListener("resize", checkSize);
    const sizeInterval = setInterval(checkSize, 2000); // Polling size less frequently

    return () => {
      document.removeEventListener("keydown", handleKeydown, { capture: true });
      document.removeEventListener("contextmenu", handleContextMenu, { capture: true });
      window.removeEventListener("resize", checkSize);
      clearTimeout(trapTimeout);
      clearInterval(consoleInterval);
      clearInterval(sizeInterval);
      trapActive.current = false;
    };
  }, []);

  return null;
}
